import type { ICountry } from "app/components/filters-bar/country-filter/CountryFilterTypes";
import { DEFAULT_ACTIVATION_WEB_SOURCE } from "app/pages/activation/routing/constants";
import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

export const isParamsInvalid = (
    params: { key: string; country: string; timeGranularity: GranularityNames; webSource: string; duration?: string },
    validId: string,
    validCountryList: ICountry[],
    validGranularity: GranularityNames[] = [GranularityNames.WEEKLY, GranularityNames.MONTHLY],
) => {
    const isIdValid = validId === params.key;
    const isCountryValid = validCountryList.some((country) => country.id === Number(params.country));
    const isTimeGranularityValid = validGranularity.includes(params.timeGranularity);
    const isWebSourceValid = params.webSource === DEFAULT_ACTIVATION_WEB_SOURCE;

    return !(isIdValid && isCountryValid && isTimeGranularityValid && isWebSourceValid);
};
